import { KeyValue } from "@angular/common";
import { UdeuCreateFile, UdeuFile } from "./udeu-files";
import { UdeuStatus } from "./udeu-status";
import { UdeuRecord } from "./udeu-record";

export class UdeuCreateBoud {
    data: UdeuBoud;
    files: UdeuCreateFile[];
}

export class UdeuBoud {
    id?: string;
    name?: string;
    status: UdeuStatus;
    data: UdeuData;
    info: UdeuInfo;
    elements: AssocElements;
    references: RefElements;
    content: UdeuContent;

    constructor() {
        this.data = new UdeuData();
        this.info = new UdeuInfo();
        this.elements = new AssocElements();
        this.content = new UdeuContent();
    }
}

export class UdeuData {
    type: string | KeyValue<string, string>;
    subtype: string | KeyValue<string, string>;
    primaryApprovingBody: string[] | KeyValue<string, string>[];
    nominalSubdivision: string[] | KeyValue<string, string>[];
    secondaryApprovingBody: string[] | KeyValue<string, string>[];
    secondaryApprovingBodySub: string[] | KeyValue<string, string>[];
    provisionNumber: string;
    actionType: string | KeyValue<string, string>;
    approvalDate: string;
    effectiveDate: string;
    observations:string;
    partialRepeal:string;
}

export class UdeuInfo {
    publicationDate: string;
    publicationUser: string;
    record: string | UdeuRecord;
}

export class AssocElements {
    mentionedElements: string[] | UdeuBoud[];
    correctedElements: string[] | UdeuBoud[];
    modifiedElements: string[] | UdeuBoud[];
    repealedElements: string[] | UdeuBoud[];
    suspendedElements: string[] | UdeuBoud[];
}

export class RefElements {
    mentionersElements: UdeuBoud[];
    modifiersElements: UdeuBoud[];
    repealersElements: UdeuBoud[];
    suspendersElements: UdeuBoud[];
    correctorsElements: UdeuBoud[];
}

export class UdeuContent {
    euskeraContent: UdeuFile;
    spanishContent: UdeuFile;
    englishContent: UdeuFile;
    euskeraGenerated: UdeuFile;
    spanishGenerated: UdeuFile;
    englishGenerated: UdeuFile;
}